<template>
    <div class="CertificateView">
        <div class="d-flex">
            <div class="mx-3">
                <div id="zarinpal">
                </div>
            </div>
            <div class="mx-3">
                <a aria-label="enamad" referrerpolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=246706&amp;Code=O2DJ52b1u6dTqh3LpIE8"><img referrerpolicy="origin" src="https://Trustseal.eNamad.ir/logo.aspx?id=246706&amp;Code=O2DJ52b1u6dTqh3LpIE8" alt="enamad" id="O2DJ52b1u6dTqh3LpIE8" class="footer-icon"></a>
            </div>
        </div>
        <p class="mt-3">برای گزارش تخلف می توانید روی هر نماد که می‌خواهید کلیک کنید.</p>
    </div>
</template>
<script>
export default {
  name: 'CertificateView',
  mounted () {
    document.getElementById('zarinpal').innerHTML = '<a aria-label="zarinpal" href="https://www.zarinpal.com/trustPage/nuorashop.ir" title="دروازه پرداخت معتبر"><img src="https://cdn.zarinpal.com/badges/trustLogo/1.svg" alt="دروازه پرداخت معتبر" class="footer-icon"></a>'
  }
}
</script>
<style scoped>
</style>
